'use client';

import { REST_SLUG, useFocusSplit } from '../../hooks/useFocusSplit';
import { MODE_COLORS, MODE_LABELS } from '../../lib/focusModes';
import styles from './FocusSplit.module.css';

const colorFor = (slug: string) =>
  slug === REST_SLUG ? '#3a3a3a' : (MODE_COLORS[slug] ?? '#666');

const labelFor = (slug: string) =>
  slug === REST_SLUG ? 'Untracked' : (MODE_LABELS[slug] ?? slug);

export const FocusSplit = () => {
  const rows = useFocusSplit();
  if (!rows.length) return null;

  return (
    <div className={styles.split}>
      <div className={styles.bar}>
        {rows.map((row) => (
          <div
            key={row.slug}
            className={styles.segment}
            style={{ flexGrow: row.minutes, background: colorFor(row.slug) }}
            title={`${labelFor(row.slug)} · ${Math.round(row.share * 100)}%`}
          />
        ))}
      </div>

      <div className={styles.legend}>
        {rows.map((row) => (
          <span key={row.slug} className={styles.item}>
            <span
              className={styles.dot}
              style={{ background: colorFor(row.slug) }}
            />
            {labelFor(row.slug)}
            <span className={styles.pct}>{Math.round(row.share * 100)}%</span>
          </span>
        ))}
      </div>
    </div>
  );
};
